export default __webpack_public_path__ + "static/media/tms-truffle-broadband.8124f4c7.webp";